import type { GetEmployeesResponse } from '@/types/Employee'
import { apiGet } from './ApiClient'

export async function getAccountManagers(): Promise<GetEmployeesResponse> {
  return await apiGet<GetEmployeesResponse>('/employees?role=accountmanager')
}
